import React, { useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");
    if (!formData.fullName || !formData.email || !formData.subject || !formData.message) {
      setErrorMessage("Please fill out all required fields.");
      return;
    }
    setLoading(true);

    try {
      // NOTE: Replace with your actual backend endpoint if deploying
      // This is a placeholder for the API call
      await new Promise(resolve => setTimeout(resolve, 1500));

      setSuccessMessage("Thank you! Our team will get back to you shortly.");
      setFormData({
        fullName: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("Submission error:", error);
      setErrorMessage("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '0',
      backgroundColor: '#f0f4f8', // Changed to light off-white
      fontFamily: "'Poppins', sans-serif",
      position: 'relative',
      overflow: 'hidden',
      color: '#1f2937', // Changed to dark text color
      minHeight: '100vh',
    }}>
      <svg
        style={{
          position: 'absolute',
          top: '-1px',
          left: '0',
          width: '100%',
          zIndex: '10',
          transform: 'rotate(180deg)',
        }}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
      >
        <path style={{ fill: '#1e293b', fillOpacity: '1' }} d="M0,288L60,266.7C120,245,240,203,360,208C480,213,600,267,720,282.7C840,299,960,277,1080,272C1200,267,1320,277,1380,282.7L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
      </svg>

      <div style={{
        maxWidth: '1280px',
        width: '100%',
        padding: '4rem 1rem',
        position: 'relative',
        zIndex: '20',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}>
        <div style={{ marginBottom: '3rem' }}>
          <p style={{
            color: '#d4b68f',
            fontSize: '0.875rem',
            fontWeight: '600',
            letterSpacing: '0.05em',
            marginBottom: '0.5rem',
            textTransform: 'uppercase',
          }}>
            Contact Us
          </p>
          <h1 style={{
            color: '#1f2937', // Changed to dark text color
            fontSize: '2.25rem',
            fontWeight: '700',
            lineHeight: '1.25',
            margin: '0',
          }}>
            Get In Touch
          </h1>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          maxWidth: '900px',
          backgroundColor: '#f8fafc', // Changed to light background
          border: '1px solid #e2e8f0', // Changed to light border
          borderRadius: '0.75rem',
          boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.05)', // Lighter shadow
          padding: '2rem',
        }}>
          <form onSubmit={handleSubmit} style={{
            width: '100%',
            flex: '1',
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem',
              marginBottom: '1rem',
            }}>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Full Name *"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #cbd5e1', // Light border
                  borderRadius: '0.375rem',
                  fontSize: '1rem',
                  backgroundColor: '#ffffff', // White background
                  color: '#1f2937', // Dark text
                  outline: 'none',
                }}
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email Address *"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #cbd5e1', // Light border
                  borderRadius: '0.375rem',
                  fontSize: '1rem',
                  backgroundColor: '#ffffff', // White background
                  color: '#1f2937', // Dark text
                  outline: 'none',
                }}
              />
            </div>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="Subject *"
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #cbd5e1', // Light border
                borderRadius: '0.375rem',
                fontSize: '1rem',
                marginBottom: '1rem',
                backgroundColor: '#ffffff', // White background
                color: '#1f2937', // Dark text
                outline: 'none',
              }}
            />
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your Message *"
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #cbd5e1', // Light border
                borderRadius: '0.375rem',
                fontSize: '1rem',
                marginBottom: '1rem',
                minHeight: '150px',
                resize: 'vertical',
                backgroundColor: '#ffffff', // White background
                color: '#1f2937', // Dark text
                outline: 'none',
              }}
            />
            {errorMessage && (
              <p style={{
                color: '#EF4444',
                backgroundColor: 'rgba(239, 68, 68, 0.2)',
                padding: '0.5rem',
                borderRadius: '0.375rem',
                textAlign: 'center',
                marginBottom: '1rem',
              }}>{errorMessage}</p>
            )}
            {successMessage && (
              <p style={{
                color: '#22C55E',
                backgroundColor: 'rgba(34, 197, 94, 0.2)',
                padding: '0.5rem',
                borderRadius: '0.375rem',
                textAlign: 'center',
                marginBottom: '1rem',
              }}>{successMessage}</p>
            )}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '1rem',
                backgroundColor: '#d4b68f',
                color: '#1e293b', // Dark button text color for contrast
                borderRadius: '0.375rem',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '2rem',
            textAlign: 'center',
            color: '#334155', // Dark text color for info section
          }}>
            <div style={{
              marginBottom: '1.5rem',
            }}>
              <FaMapMarkerAlt size={24} style={{ color: '#d4b68f', marginBottom: '0.5rem', display: 'block', margin: '0 auto' }} />
              <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#1f2937', margin: '0' }}>Location</h3>
              <p style={{ fontSize: '0.875rem', color: '#475569' }}>2nd Floor, Pitambara Plaza, Madhuvan Colony,<br /> Mayur Nagar, Thatipur, Gwalior, Madhya Pradesh 474011</p>
            </div>
            <div style={{
              marginBottom: '1.5rem',
            }}>
              <FaPhoneAlt size={24} style={{ color: '#d4b68f', marginBottom: '0.5rem', display: 'block', margin: '0 auto' }} />
              <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#1f2937', margin: '0' }}>Phone</h3>
              <p style={{ fontSize: '0.875rem', color: '#475569' }}>+91  8358988705 <br /></p>
            </div>
            <div>
              <FaEnvelope size={24} style={{ color: '#d4b68f', marginBottom: '0.5rem', display: 'block', margin: '0 auto' }} />
              <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#1f2937', margin: '0' }}>Email</h3>
              <p style={{ fontSize: '0.875rem', color: '#475569' }}>girrajtechnology@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;